import * as React from 'react'
import { ReturnsAndExchangesModuleProps, ReturnsAndExchangesKindProps } from './types'
import { ModuleLayout } from '../../components/ModuleLayout'
import { TabButton } from '../../components/TabButton'
import './index.scss'
import { RedirectButton } from '../../components/RedirectButton'
import { TitleAndDescription } from '../../components/TitleAndDescription'
import { SegmentContext } from '../../hooks/SegmentContext'

export const ReturnsAndExchangesModule: React.FC<ReturnsAndExchangesModuleProps> = ({ moduleTitle, kinds }) => {
  const { segmentTrack } = React.useContext(SegmentContext)
  const [activeKind, setActiveKind] = React.useState<ReturnsAndExchangesKindProps>(kinds[0])
  const hasMoreInfoButton = activeKind?.moreInfo || (activeKind?.moreInfoHref && activeKind?.moreInfoTitle)
  const hasRedirectButton = activeKind?.redirectButton || (activeKind?.redirectButtonTitle && activeKind?.redirectButtonHref)

  const moreInfoTitle = activeKind?.moreInfoTitle ?? activeKind?.moreInfo?.title
  const safeMoreInfoTitle = moreInfoTitle ?? ''

  const moreInfoHref = activeKind?.moreInfoHref ?? activeKind?.moreInfo?.href
  const safeMoreInfoHref = moreInfoHref ?? ''

  const redirectButtonTitle = activeKind?.redirectButton?.title ?? activeKind?.redirectButtonTitle
  const safeRedirectButtonTitle = redirectButtonTitle ?? ''

  const redirectButtonHref = activeKind?.redirectButton?.href ?? activeKind?.redirectButtonHref
  const safeRedirectButtonHref = redirectButtonHref ?? ''

  function handleKindClick(kind: ReturnsAndExchangesKindProps) {
    segmentTrack('Help Option Clicked', { widget: true, alt_text: 'ajuda-alt', help_section: 'Trocas e devoluções', help_subsection: kind.title, button_name: kind.title })
    setActiveKind(kind)
  }

  return (
    <ModuleLayout>
      <div className="return-exchange-container">
        <div className="module-content">
          <h1 className="module-title">{moduleTitle}</h1>
          {kinds.length > 0 ? (
            <div className="kind-selector-container">
              {kinds.map((kind) => {
                return <TabButton key={kind.title} title={kind.title} isActive={kind.id === activeKind.id} onClick={() => handleKindClick(kind)} />
              })}
            </div>
          ) : null}
          <div className="kind-text-content">
            {activeKind?.items?.map((text) => {
              return <TitleAndDescription key={text.title} title={text.title} description={text.description} />
            })}
            {hasMoreInfoButton ? (
              <RedirectButton
                rightIconName="arrow-right"
                title={safeMoreInfoTitle}
                href={safeMoreInfoHref}
                kind="text"
                section="Trocas e Devoluções"
                subSection={activeKind.title}
              />
            ) : null}
          </div>
        </div>
        {hasRedirectButton ? (
          <RedirectButton
            rightIconName="arrow-right"
            title={safeRedirectButtonTitle}
            href={safeRedirectButtonHref}
            kind="outline"
            section="Trocas e Devoluções"
            subSection={activeKind.title}
          />
        ) : null}
      </div>
    </ModuleLayout>
  )
}
